let safelist = []
try {
  safelist = require('./safelist.js');
} catch(e) {
  console.info('Project does not have custom safelist.js');
}
module.exports = {
  defaultDomain: 'https://ttecdigital.ddev.site',
  dest: {
    public: `web`,
    css: `assets/css`,
    js: `assets/js`,
    images: `assets/images`,
    fonts: `assets/fonts`
  },
  jsFiles: [
    `src/js/app.js`
  ],
  sassFiles: [
  ],
  cssFiles: [
    `src/css/app.css`,
  ],
  imageDirectories: [
    `src/images`
  ],
  fontDirectories: [
    `src/fonts`
  ],
  staticDirectories: [
    { src: `src/static`, dest: `web/assets/static/` }
  ],
  watchFiles: [
    'templates/**/**.*',
    `web/**/**.*`
  ],
  content: [
    `./src/js/**/**.js`,
    './templates/**/**.{twig,html}',
  ],
  tailwindconfig: './tailwind.config.js'
}

